import { CalendarIcon } from "lucide-react";

import { cn } from "../../lib/utils";

interface DateInputFieldProps {
  label: string;
  labelColor: string;
  placeholder: string;
  disabled: boolean;
  invalid: boolean;
  name: string;
  className?: string;
}

export default function DateInputField({
  label,
  labelColor,
  placeholder,
  disabled,
  invalid,
  name,
  className,
}: Readonly<DateInputFieldProps>) {
  return (
    <div
      aria-invalid={invalid ? "true" : undefined}
      className={cn(
        "group flex h-9 cursor-pointer items-center justify-between rounded-md border px-3",
        "border-brand-gray hover:border-brand-blue w-full min-w-0",
        disabled && "pointer-events-none",
        invalid
          ? "border-destructive ring-destructive/20 dark:ring-destructive/40 hover:border-brand-red"
          : "border-brand-gray hover:border-brand-blue",
        className,
      )}
      data-testid={`date-picker-field-${name}`}
    >
      <span
        className={cn(
          "max-w-[85%] min-w-0 truncate text-sm font-normal transition-colors",
          labelColor,
        )}
      >
        {label || placeholder}
      </span>
      <CalendarIcon className="text-brand-gray h-4 w-4" />
    </div>
  );
}
